import { all } from 'redux-saga/effects';
import { authSagas } from './auth/auth.saga';
import { makeReservationSagas } from './shared/make-reservation.saga';
import { landingSagas } from './customers/landing.saga';
import { reservationsListSagas } from './shared/reservations-list.saga';
import { privateRouteSagas } from './shared/private-route.saga';
import { handleReservationSagas } from './admin/handle-reservation.saga';
import { sendEmailSagas } from './shared/send-email.saga';
import { editProfileSagas } from './customers/edit-profile.saga';
import { roomsSagas } from './customers/rooms-list.saga';
import { uploadCsvSagas } from './customers/upload-csv.saga';
import { eventsListSagas } from './shared/events-list.saga';
import { listAttendeesSagas } from './customers/liste-attendees.saga';
import { TbRegistrationSagas } from './user.saga';

function* sagas() {
  yield all([
    authSagas(),
    makeReservationSagas(),
    landingSagas(),
    reservationsListSagas(),
    privateRouteSagas(),
    handleReservationSagas(),
    sendEmailSagas(),
    editProfileSagas(),
    roomsSagas(),
    uploadCsvSagas(),
    eventsListSagas(),
    listAttendeesSagas(),
    TbRegistrationSagas()
  ]);
}

export default sagas;
